import React, { useContext, useEffect, useState } from "react";
import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import {
  ToastContextDispatch,
  SuccessfullyMessageBarDispatch,
} from "Context/CommonContext";
import {
  ADD_DOCUMENT_TYPE,
  BASE_URL,
} from "utilFunctions/Constants/urlConstants";
import "./index.css";
import { Button, Form, Input, Modal } from "antd";

export const documentType = {
  value: new RegExp("^(?! )[A-Za-z0-9 ]*(?<! )$", "ig"),
  message: "White spaces and characters are not allowed.",
};
const AddDocumentType = (props: any) => {
  const { isOpen, toggle, addNewDocumentTypeHandler } = props;
  const [form] = Form.useForm();
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const successMessageInfor = useContext<any>(SuccessfullyMessageBarDispatch);
  const [isKeyboardVisible, setKeyboardVisible] = useState(false);
  const handleResize = () => {
    if (window.innerHeight < window.screen.height) {
      // Keyboard is open
      setKeyboardVisible(true);
    } else {
      // Keyboard is closed
      setKeyboardVisible(false);
    }
  };

  useEffect(() => {
    const handleKeyboardShow = () => {
      setKeyboardVisible(true);
    };

    const handleKeyboardHide = () => {
      setKeyboardVisible(false);
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("keyboardDidShow", handleKeyboardShow);
    window.addEventListener("keyboardDidHide", handleKeyboardHide);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("keyboardDidShow", handleKeyboardShow);
      window.removeEventListener("keyboardDidHide", handleKeyboardHide);
    };
  }, []);

  const { makeRequest: postAddDocumentType, loading } = usePutPostAPI(
    (data: any) => {
      ToastDispatch({
        isOpen: true,
        type: "Success",
        message: data["detailMessage"] || data["message"],
      });
      successMessageInfor({
        message: "Document type added successfully!",
        isShow: true,
      });
      addNewDocumentTypeHandler();
      toggle();
      form.resetFields();
    },
    (error) => {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message:
          error["response"]["data"]["internalCode"] ||
          error["response"]["data"]["message"],
      });
    },
    "POST"
  );
  const onFinish = (values: any) => {
    postAddDocumentType(BASE_URL + ADD_DOCUMENT_TYPE, values);
  };
  return (
    <div
      className={isKeyboardVisible ? "keyboard-visible-style" : "normal-style"}
    >
      <Modal
        title="Add Document Type"
        open={isOpen}
        onCancel={() => {
          toggle();
          form.resetFields();
        }}
        footer={false}
      >
        <Form
          layout={"vertical"}
          className="w-100"
          size="middle"
          onFinish={onFinish}
          form={form}
        >
          <Form.Item
            label="Document Type"
            name="documentType"
            rules={[
              { required: true, message: "Please input Document Type!" },
              {
                pattern: documentType.value,
                message: documentType.message,
              },
            ]}
          >
            <Input size="middle" type={"text"} />
          </Form.Item>
          <div className="d-flex justify-content-end align-items-end">
            <Button loading={loading} htmlType="submit" type="primary">
              Add
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};
export default AddDocumentType;
